import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Text = styled.span`
  color: ${props => props.theme.palette.gray[50]};
  cursor: default;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const ExternalLink = styled.a`
  color: ${props => props.theme.palette.gray[50]};
  cursor: default;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const InternalLink = styled(Link)`
  color: ${props => props.theme.palette.gray[50]};
  cursor: default;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-decoration: none;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`
